import { guardArray } from "../array";
import type { CheckInRequirements, Nullable } from "../types";

/**
 * The check-in steps a user still has to walk through, in the order they are shown.
 *
 * The texts come before the documents: a definition is read at a glance, a risk assessment is a
 * PDF, so an abort on the cheap step costs nothing. A step with nothing to confirm is left out —
 * with both lists empty the check-in goes straight through.
 *
 * @param requirements - The requirements for the worksite the user is checking in on.
 * @returns The pending steps, empty when nothing stands between the user and the check-in.
 */
export function getPendingCheckInSteps(
	requirements: Nullable<CheckInRequirements>,
): Array<"acknowledgements" | "riskAssessments"> {
	const steps: Array<"acknowledgements" | "riskAssessments"> = [];
	if (guardArray(requirements?.acknowledgementDefinitions).length > 0) {
		steps.push("acknowledgements");
	}
	if (guardArray(requirements?.riskAssessments).length > 0) {
		steps.push("riskAssessments");
	}
	return steps;
}
